import { render } from "./VentasList.vue?vue&type=template&id=00ea31cd&scoped=true"
import script from "./VentasList.vue?vue&type=script&lang=js"
export * from "./VentasList.vue?vue&type=script&lang=js"

import "./VentasList.vue?vue&type=style&index=0&id=00ea31cd&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ea31cd"]])

export default __exports__